import React from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import About from "../Assests/Whi.jpg";

const BannerSection = () => {
    return (
        <Box
            sx={{
                width: {md:"100%",xs:"100%"},
                height: {md:"70vh",xs:"100vh",sm:"75vh"},
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#981c1c", // Dark background color
                color: "white", // Ensures text is visible on dark background
            }}
        >
            <Grid container sx={{ height: "100%" }}>
                {/* Image Section */}
                <Grid item xs={12} md={6}>
                    <Box
                        sx={{
                            width: { md: "100%", xs: "80%" },
                            height: { md: "100%", xs: "200%" },
                            backgroundImage: `url(${About})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            marginLeft:{xs:"40px"}
                        }}
                    />
                </Grid>

                {/* Information Section */}
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center", 
                        textAlign: {md: "justify" },
                        padding: "20px",
                        textAlign: "justify",
                        marginLeft:{md:"-20px"}
                    }}
                >
                    <Typography
                        variant="h4"
                        gutterBottom
                        sx={{
                            fontWeight: "bold", 
                            fontSize: { xs: "24px", sm: "32px", md: "35px" },
                             // Adjustable size
                        }}
                    >
                        Confused which BTech College suits you?
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                    Choosing the right BTech College Bangalore can feel overwhelming, but it doesn’t have to be. If you’re wondering where to start or how to decide, we’re here to guide you every step of the way. Explore, compare, and discover colleges that align with your dreams and goals. Turn your confusion into confidence and take the first step toward building a brighter future today with us!
                    </Typography>

                    {/* Explore More Button */}
                    <Button
                        component="a"
                        href="https://www.getmycollege.com/colleges?state=karnataka&stream=-engineering"
                        variant="contained"
                        sx={{
                            mt: 2,
                            backgroundColor: "#fff",
                            color: "#981c1c",
                            fontWeight: "bold",
                            padding: "10px 20px",
                            '&:hover': {
                                backgroundColor: "#f0f0f0",
                            },
                        }}
                    >
                        Explore More
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default BannerSection;
